<h6 for="">
  Client Shipping Addresses
  <button
    type="button"
    mat-mini-fab
    color="accent"
    aria-label="New shipping address"
    (click)="openPopupForm()"
  >
    <i class="fas fa-plus"></i>
  </button>
</h6>

<div>
  <mat-radio-group
    aria-label="Select default"
    [(ngModel)]="defaultShippingAddressId"
    (change)="setDefaultShipping()"
  >
    <div
      *ngFor="let shipping of shippingAddresses$ | async; let i = index"
      class="card-shipping-address p-2 mb-1 card"
    >
      <div class="action">
        <mat-radio-button
          [value]="shipping.id"
          title="Set as default"
        ></mat-radio-button>
        <a
          (click)="openPopupForm(shipping)"
          class="text-info mr-2"
          title="Edit shipping address"
          href="javascript:void(0);"
        >
          <i class="fas fa-edit"></i
        ></a>
        <a
          *ngIf="!shipping.default"
          (click)="delete(shipping, i)"
          class="text-danger mr-2"
          title="Delete shipping address"
          href="javascript:void(0);"
        >
          <i class="fas fa-trash"></i
        ></a>
      </div>
      <div class="details">
        <div class="basic-info">
          <div class="company">
            <i class="fas fa-building"></i>
            {{ shipping.companyName }}
          </div>
          <div class="address">
            <i class="fas fa-map-marker"></i>
            {{ shipping | transformAddress }}
          </div>
        </div>
      </div>
    </div>
  </mat-radio-group>
</div>
